// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';

function BuildingSvg() {
    return (
        <svg
            width='136'
            height='105'
            viewBox='0 0 136 105'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M106.534 105C119.472 94.0855 127.691 77.7525 127.691 59.5C127.691 26.6391 101.052 0 68.1909 0C35.33 0 8.69092 26.6391 8.69092 59.5C8.69092 77.7525 16.9097 94.0855 29.8483 105H106.534Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.08'
            />
            <path
                d='M133.265 57L133.265 48.2903L22.4626 48.2903L22.4625 38.5L6.26504 38.5'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeLinecap='round'
            />
            <path
                d='M77.7324 19.9756L77.7324 36.0406L61.9649 36.0406'
                stroke='var(--center-channel-color)'
                strokeOpacity='0.24'
                strokeLinecap='round'
            />
            <ellipse
                cx='1.4875'
                cy='1.4875'
                rx='1.4875'
                ry='1.4875'
                transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 134.83 56)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <ellipse
                cx='1.4875'
                cy='1.4875'
                rx='1.4875'
                ry='1.4875'
                transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 79.2202 17)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <ellipse
                cx='1.4875'
                cy='1.4875'
                rx='1.4875'
                ry='1.4875'
                transform='matrix(-1 -1.74846e-07 -1.74846e-07 1 7.74023 37)'
                fill='var(--center-channel-color)'
                fillOpacity='0.48'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.7651 66H35.7651V105H22.7651H18.7651H15.7651H12.7651H5.76514V75.9574H15.7651V84.2553H18.7651V66ZM115.765 66H98.7651V105H110.765H115.765H118.765H121.765H129.765V86.7447H121.765V76.7872H115.765V66Z'
                fill='var(--center-channel-bg)'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M18.7651 66H35.7651V105H22.7651H18.7651H15.7651H12.7651H5.76514V75.9574H15.7651V84.2553H18.7651V66ZM115.765 66H98.7651V105H110.765H115.765H118.765H121.765H129.765V86.7447H121.765V76.7872H115.765V66Z'
                fill='var(--center-channel-color)'
                fillOpacity='0.24'
            />
            <rect
                x='34.2651'
                y='31.5'
                width='36'
                height='71'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='31.7651'
                y='102'
                width='72'
                height='3'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='32.2651'
                y='102.5'
                width='71'
                height='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
                stroke='var(--center-channel-color)'
            />
            <rect
                x='32.2651'
                y='28.5'
                width='40'
                height='3'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='32.2651'
                y='28.5'
                width='40'
                height='3'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='39.2651'
                y='25.5'
                width='25'
                height='3'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='39.2651'
                y='25.5'
                width='25'
                height='3'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='39.7651'
                y='37'
                width='25'
                height='7'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='39.7651'
                y='48'
                width='25'
                height='7'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='39.7651'
                y='59'
                width='25'
                height='7'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='53.7651'
                y='43'
                width='5'
                height='59'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='39.7651'
                y='70'
                width='25'
                height='7'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='39.7651'
                y='81'
                width='25'
                height='7'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='47.7651'
                y='94'
                width='9'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='57.2651'
                y='43.5'
                width='47'
                height='61'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='57.2651'
                y='43.5'
                width='47'
                height='61'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='61.7651'
                y='48'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='81.7651'
                y='48'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='91.7651'
                y='48'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='71.7651'
                y='48'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='61.7651'
                y='59'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='81.7651'
                y='59'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='91.7651'
                y='59'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='71.7651'
                y='59'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='61.7651'
                y='70'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='81.7651'
                y='70'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='91.7651'
                y='70'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='71.7651'
                y='70'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='61.7651'
                y='81'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='81.7651'
                y='81'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='91.7651'
                y='81'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='71.7651'
                y='81'
                width='7'
                height='8'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
            />
            <rect
                x='81.7651'
                y='35'
                width='12'
                height='6'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
            />
            <line
                x1='5.76514'
                y1='104.5'
                x2='129.765'
                y2='104.5'
                stroke='var(--center-channel-color)'
            />
            <rect
                x='54.2651'
                y='40.5'
                width='53'
                height='3'
                fill='var(--center-channel-bg)'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='54.2651'
                y='40.5'
                width='53'
                height='3'
                fill='var(--center-channel-color)'
                fillOpacity='0.32'
                stroke='var(--center-channel-color)'
                strokeLinejoin='round'
            />
            <rect
                x='77.2651'
                y='92.5'
                width='7'
                height='12'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
                stroke='var(--center-channel-color)'
            />
            <rect
                x='55.7651'
                y='102'
                width='51'
                height='3'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='56.2651'
                y='102.5'
                width='50'
                height='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
                stroke='var(--center-channel-color)'
            />
            <rect
                x='70.7651'
                y='100'
                width='21'
                height='3'
                fill='var(--center-channel-bg)'
            />
            <rect
                x='71.2651'
                y='100.5'
                width='20'
                height='2'
                fill='var(--center-channel-color)'
                fillOpacity='0.16'
                stroke='var(--center-channel-color)'
            />
        </svg>
    );
}

export default BuildingSvg;
